import axios from "axios";
import React from "react";

import { Form, Formik } from "formik";
import { useLocation } from "react-router-dom";

import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import lock_img from "../../assets/password.svg";
import BZLogo from "../../components/BZLogo";
import { TwInputGroup, TwMainLayout } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { useTenant } from "../../provider/TenantProvider";
import AuthShell, { AuthHeading, PrimaryAuthButton, StepBar } from "../../components/auth/AuthShell";
import { defaultDomainList } from "../../utils/constants";

export default function ResetPassword({ navigation }) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, closeNotificationDialog } = useToast();
  const { tenant, tenantData, tenantLoading } = useTenant();
  const club = defaultDomainList.indexOf(tenant) < 0 && tenantData?.business_details ? tenantData.business_details : null;
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  if (!location.state) {
    navigation("/");
  }


  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <AuthShell club={club} brandTitle="Locked out?" brandLine="We text a code to your mobile, you pick a new password.">
        {location.state && (<div className="flex flex-col gap-6">
          <StepBar step={3} />
          <AuthHeading title="Choose a new password">You'll use it to sign in from now on.</AuthHeading>
          <Formik
            initialValues={{
              password: "",
            }}
            validate={(values) => {
              const errors = {};
              if (!values.password) {
                errors.password = "Required!";
              }

              return errors;
            }}
            onSubmit={async (values) => {

              dispatch(setActionLoading(true));
              const request = await axios.put(
                `${getUrlForUsers()}resetForgotPassword`,
                {
                  password: values.password,
                  token: location.state.token,
                }
              );

              dispatch(setActionLoading(false));
              if (request.data.statusCode === 200) {
                addNotificationDialog({
                  dialogType: "success",
                  dialogTitle: "Success",
                  dialogMessage: "Your password changed successfully",
                  dialogBtnTitle: "Go back to Login",
                  dialogBackdropClick: async () => {
                    closeNotificationDialog();
                    navigation("/");
                  },
                  dialogBtnClick: async () => {
                    closeNotificationDialog();
                    navigation("/");
                  },
                })
              } else {
                addErrorToast(request.data.message);
              }
            }}
          >
            {({
              values,
              errors,
              setFieldValue,
              handleBlur,
              submitForm,
              isSubmitting,
            }) => (
              <Form>
                <div className={"flex flex-col gap-5"}>

                  <TwInputGroup
                    label={"New password"}
                    placeholder={"Your new password"}
                    name={"password"}
                    type={passwordVisible ? "text" : "password"}
                    leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                    rightIcon={
                      <button type="button" className="flex" aria-label={passwordVisible ? "Hide password" : "Show password"} onClick={() => setPasswordVisible(!passwordVisible)}>
                        {passwordVisible ? <EyeIcon className="size-5" /> : <EyeSlashIcon className="size-5" />}
                      </button>
                    }
                    onChange={(e) => {
                      setFieldValue("password", e.target.value);
                    }}
                    errors={errors}
                  />
                  <PrimaryAuthButton busy={loadingReduxState.actionLoading || isSubmitting}>Save new password</PrimaryAuthButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>)}
      </AuthShell>
    </TwMainLayout>)
}
